export default "<input type=\"input\" currencyMask [options]=\"options\" [formControl]=\"formControl\" [formlyAttributes]=\"field\" matInput />\n";